export enum CostEffectivenessDisplay {
  Loading = -1000,
  Error = -2000,
}
